import { createRouter, createWebHistory } from 'vue-router'

import MainLayout from '../views/layouts/main-layout/MainLayout'
import { setLastTab } from '@/router/utils/lastTabStorage'

import { dossierPages } from './dossiers'
import { loginRootPages } from './login/index'
import { screenRootPages } from './screen/index'
import { calendarPages } from './calendar'
import { invoicingPages } from './invoicing'
import { noteRootPages } from '@/router/note'
import { settingsSubPages } from './settings/index'
import { saManagementSubPages } from './sa_management/index'
import { profileRootPages } from './profile/index'

import { contactsRootPages, contactsSubPages } from './contacts/index'
import { wikiRootPages, wikiSubPages } from './wiki/index'
import { tasksSubPages } from './tasks/index'
import { partnersRootPages } from './partners/index'
import { statisticsRootPages, statisticsSubPages } from '@/router/statistics'
import { chatRootPages } from '@/router/chat'
import { supplierOrderSubPages } from '@/router/supplierOrder'
import { versionNoteRootPages } from '@/router/versionNote'
import { templateDashboardSubPages } from '@/router/templateDashboard'
import { modelNotificationRootPages } from '@/router/modelNotification'
import { electronicSignatureRootPages } from '@/router/electronicSignature'
import { stockSubPages } from '@/router/stock'
import { catalogRootPages } from '@/router/catalog/catalog'
import { marketplacePages } from '@/router/marketplace'
import { analyticsPages } from '@/router/analytics'
import { personRootPages } from '@/router/person'
import { condolenceRootPages } from '@/router/condolence'
import { activityLogsPages } from '@/router/activityLog'
import { exportSubPages } from '@/router/export'
import { scheduledTaskSubPages } from '@/router/scheduledTask'

const routes = [
  ...loginRootPages,
  ...screenRootPages,
  {
    path: '/',
    name: 'root',
    component: MainLayout,
    children: [
      {
        path: '',
        name: 'root_base',
        //rendre ici la redirection dynamique.. store.getters['auth/getAuth']['settings'][landing_page]]
        redirect: { name: 'dashboard_dossier_main_page_route' }
      },
      ...[
        { ...contactsRootPages },
        { ...noteRootPages },
        { ...partnersRootPages },
        { ...noteRootPages },
        { ...profileRootPages },
        { ...statisticsRootPages },
        { ...wikiRootPages }
      ],
      ...analyticsPages,
      ...marketplacePages,
      ...personRootPages,
      ...calendarPages,
      ...chatRootPages,
      ...contactsSubPages,
      ...dossierPages,
      ...invoicingPages,
      ...modelNotificationRootPages,
      ...saManagementSubPages,
      ...settingsSubPages,
      ...statisticsSubPages,
      ...supplierOrderSubPages,
      ...tasksSubPages,
      ...templateDashboardSubPages,
      ...chatRootPages,
      ...versionNoteRootPages,
      ...catalogRootPages,
      ...wikiSubPages,
      ...electronicSignatureRootPages,
      ...stockSubPages,
      ...condolenceRootPages,
      ...activityLogsPages,
      ...exportSubPages,
      ...scheduledTaskSubPages
    ]
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        el: to.hash
      }
    }
    if (savedPosition) {
      return savedPosition
    }
    return { left: 0, top: 0 }
  }
})

router.afterEach((to) => {
  if (to.name === 'dashboard_page_route') {
    setLastTab('dashboard:last_tab_id', to.params.id)
  } else if (to.name === 'dashboard_dossier_page_route') {
    setLastTab('dashboard_dossier:last_tab_id', to.params.id)
  } else if (
    to.meta?.isDossierPage &&
    (!to.meta?.display_type || to.meta.display_type === 'view') &&
    Object.keys(to.params).length === 1
  ) {
    // Only cache tabs reachable with the dossier id alone — some subpages
    // (document preview, wiki documents...) require extra params we don't have on redirect.
    setLastTab('dossier:last_subpage_route_name', to.name)
  }
})

export default router
